(function($){
  var $doc = $(document);
  var $win = $(window);

  $doc.ready(function(){
    // Lazy Load
    var lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy-load",
      callback_loaded: function(el){
        makeSquare();
      }
    });
    makeSquare();

    // close newsletter popup from a different button
    $('.close-popup').click(function(e){
      e.preventDefault();
      $('.pum-close').trigger('click');
    });

    // Toggle Mobile Menu
    $('#mobileMenuToggle, .mobile-menu .close-btn').on('click', function (e) {
      e.preventDefault();
      $('#page').toggleClass('menu--open');
    });

    // $('.wpforms-field-select select').select2({
    //   minimumResultsForSearch: -1,
    // });

    // Video Player for Homepage
    $(".video-bg-player").mediaelementplayer({
      //Settings here
      stretching: 'fill',
      videoWidth: '100%',
      videoHeight: '100%',
      //enableAutosize: true,
      loop: true,
      hideVideoControlsOnLoad: true,
      shimScriptAccess: "always",
      pauseOtherPlayers: false,
      startVolume: 0,
      success: function(mediaElement, originalNode, instance) {
        // store the instance
        $(mediaElement).data("mediainstance", instance);
      },
    });

    // Initialize slider for Homepage rights 101
    $('.rights-container').each(function () {
      var elem = $(this).get();
      var swiper = new Swiper(elem, {
        speed: 400,
        loop: true,
        navigation: {
          nextEl: '.rights-button-next',
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
      })
    });

    // Initialize slider for hero testimonials
    $('.testimonial-container').each(function () {
      var elem = $(this).get();
      var swiper = new Swiper(elem, {
        speed: 400,
        loop: true,
        navigation: {
          nextEl: '.testimonial-button-next',
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
      })
    });

    // Initialize slider for project gallery
    $('.gallery-slider').each(function () {
      var elem = $(this).get();
      var swiper = new Swiper(elem, {
        speed: 400,
        loop: true,
        navigation: {
          prevEl: '.gallery-button-previous',
          nextEl: '.gallery-button-next',
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
      })
    });

    var $btnArrow = '<span class="btn-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="21" viewBox="0 0 35 21"><path fill="#FFFFFF" fill-rule="evenodd" stroke="#FFFFFF" stroke-width=".5" d="M25.351 1.163a.551.551 0 00-.756-.024.552.552 0 00-.025.75l7.667 8.082H1.532A.531.531 0 001 10.5c0 .29.24.528.532.528h30.705l-7.667 8.082a.548.548 0 00.025.75c.203.19.534.194.756-.025l8.517-8.972a.563.563 0 000-.726L25.35 1.163z"/></svg></span>';
    var $btnArrowSmall = '<span class="btn-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="12" viewBox="0 0 19 12"><path fill="#0360B2" fill-rule="evenodd" stroke="#0360B2" stroke-width=".5" d="M13.283 1.086a.309.309 0 00-.413-.013.283.283 0 00-.014.395l4.183 4.254H.29c-.16 0-.29.124-.29.277 0 .153.13.278.29.278H17.04l-4.183 4.254a.28.28 0 00.014.395c.11.1.291.102.413-.013l4.645-4.723a.289.289 0 000-.382l-4.645-4.722z"/></svg></span>';
    // Adds arrow to buttons
    $('.has-arrow').each(function () {
      $(this).append($btnArrow)
    });
    $('.has-arrow-sm').each(function () {
      $(this).append($btnArrowSmall)
    });
    // Adds waves for hover
    $('.has-waves').each(function () {
      var t = $(this);
      if(!t.children('.btn-text').length){
        // wrap the content in the .btn-text span if not there
        var btnText = t.text();
        var arrow = '';
        if(t.children('.btn-arrow').length){
          arrow = t.children('.btn-arrow');
        }
        var span = $('<span>', {class: 'btn-text'});
        span.html(btnText);
        t.html(span);
        t.append(arrow);
      }
      t.append('<div class="btn-waves"></div>');
    });

    $('.sticky').each(function(){
      $(this).sticky({
        topSpacing: 0,
        bottomSpacing: $('.site-footer').outerHeight() + 86,
      });
    });

    // copy to clipboard buttons
    $('.btn-copy').on('click', function(e){
      var t = $(this);
      var text = t.data('text');
      copyTextToClipboard(text);
      t.find('span').text('Copied!');
      setTimeout(function(){
        t.find('span').text('Copy');
      }, 5000);
    });

    // Site Menu
    $('.site-header .menu-item-has-children').each(function () {
      var $menuTitle = $(this).find('.nav-link').first().text();
      var $menuDescription = $(this).find('.menu-item-description').first().text();
      var $menuMenu = $(this).find('.dropdown-menu').first().html();

      if ($menuMenu.length) {
        //console.log($menuTitle);
        $(this).hover(
          function () {
            $('.site-sub-header').addClass("hover");
            $('.sub-header-menu-title').text($menuTitle);
            $('.sub-header-menu-description').text($menuDescription);
            $('.sub-header-menu-links').html($menuMenu);
            $('.list-arrow .menu-item .dropdown-item').each(function () {
              $(this).prepend($btnArrowSmall)
            });
          },
          function () {
            //$('.site-sub-header').removeClass("hover");
          }
        ) 
      }
    });

    // Site Menu Mobile
    $('#primary-menu-mobile .menu-item-has-children').each(function () {
      var $menuTitle = $(this).find('.nav-link').first().text();
      var $menuDescription = $(this).find('.menu-item-description').first().text();
      var $menuMenu = $(this).find('.dropdown-menu').first().html();

      if ($menuMenu.length) {
        //console.log($menuTitle);
        $(this).click(function () {
            // console.log('clicked');
            //$('.dropdown-toggle.nav-link').preventDefault();
            $('.site-sub-header').addClass("hover");
            $('.sub-header-menu-title').text($menuTitle);
            $('.sub-header-menu-description').text($menuDescription);
            $('.sub-header-menu-links').html($menuMenu);
            $('.list-arrow .menu-item .dropdown-item').each(function () {
              $(this).prepend($btnArrowSmall)
            });
          }
        );
        $('.site-sub-header-close').click(function () {
          $('.site-sub-header').removeClass("hover");
        });
      }
    });

    $(".site-sub-header").mouseleave(function () {
      $(this).removeClass("hover");
    });
    $(".site-header .menu-item:not(.menu-item-has-children)").mouseenter(function(){
      $(".site-sub-header").removeClass("hover");
    });



    $('.wavify').each(function(){
      var t = $(this);
      var container = t.parents('.wave-container');
      //console.log(container);
      var height = container.height() * parseFloat(t.data('height'));
      var amplitude_ratio = t.data('amplitude-ratio') ? parseFloat(t.data('amplitude-ratio')) : 1;
      var amplitude = (height / 2) * amplitude_ratio;
      var options = {
        container: container.get(0),
        height: height,
        bones: t.data('bones') ? t.data('bones') : 2,
        amplitude: amplitude,
        color: t.data('color') ? t.data('color') : '#EFF0F2',
        speed: t.data('speed') ? t.data('speed') : 0.5,
        factorLimiter: 5,
        inverted: t.data('inverted') ? true : false,
      }
      t.wavify(options);
    });

  });

  $win.on('resize', function(){
    makeSquare();
  });

  $win.load(function () {

  });

  function makeSquare(){
    var $squared = $('.squared');
    $.each($squared, function() {
      var $element = $(this);
      var elementWidth = $element.outerWidth();
      $element.css('height', elementWidth);
    });
  }

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
  
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }
  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

})(jQuery);